<slick-dialog key="DIALOG_CRM_EDIT" [header]="dialogHeader" height="700" width="1000" #dialogRef>
	<div *ngIf="customerModel">
		<crm-edit [customerModel]="customerModel"></crm-edit>
	</div>

	<slick-dialog-footer>
		<div class="d-flex">
			<button type="button"
					class="btn btn-outline-success me-3"
					style="width: 140px;"
					[slick-button-spinner]="spinnerStatus"
					(click)="onSave()">
				<i class="bi bi-check-circle"></i> Save
			</button>
			<button type="button"
					class="btn btn-outline-danger"
					style="width: 140px;"
					(click)="onCancel()">
				<i class="bi bi-x-circle"></i> Cancel
			</button>
		</div>
	</slick-dialog-footer>
</slick-dialog>
